var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9333 10H38V40H5.06667V10H10.1333V7.5H12.6667V10H30.4V7.5H32.9333V10ZM35.4667 12.5H32.9333V15H35.4667V12.5ZM30.4 12.5H12.6667V15H30.4V12.5ZM10.1333 12.5H7.6V15H10.1333V12.5ZM7.6 37.5H35.4667V17.5H7.6V37.5ZM5.06667 7.5V5H2.53333V32.5H0V2.5H5.06667V0H7.6V2.5H25.3333V0H27.8667V2.5H32.9333V5H27.8667V7.5H25.3333V5H7.6V7.5H5.06667ZM12.6667 27.5V25H15.2V27.5H12.6667ZM17.7333 27.5V25H20.2667V27.5H17.7333ZM22.8 27.5V25H25.3333V27.5H22.8ZM27.8667 27.5V25H30.4V27.5H27.8667ZM12.6667 32.5V30H15.2V32.5H12.6667ZM17.7333 32.5V30H20.2667V32.5H17.7333ZM22.8 32.5V30H25.3333V32.5H22.8ZM17.7333 22.5V20H20.2667V22.5H17.7333ZM22.8 22.5V20H25.3333V22.5H22.8ZM27.8667 22.5V20H30.4V22.5H27.8667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoi);
export default __webpack_public_path__ + "static/media/YOI.bda351ab4c44a5381f9581d370e21609.svg";
export { ForwardRef as ReactComponent };